export default "__VITE_ASSET__hom26E4b__"